import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const UserMenuBalanceLabelDefaultBox = styled.div`
    white-space: nowrap;
    font-size: 1.4rem;
    color: ${({theme}) => theme.colors.textContrast};
    font-weight: 600;
`;

const UserMenuBalanceLabelCasino777Box = styled(UserMenuBalanceLabelDefaultBox)`
    color: ${({theme}) => theme.colors.text};
`;

export const UserMenuBalanceLabelBox = styledByTheme(UserMenuBalanceLabelDefaultBox)
    .forCasino777(UserMenuBalanceLabelCasino777Box)
    .apply();
